<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base>
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h2>THANK YOU FOR YOUR SAMPLE REQUEST</h2>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body">
                    <b-container>
                        <b-row>
                            <b-col class="text-center">
                                <h4>We process your sample request within the next 24 hours.</h4>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>
<script>

    export default {
        name: 'sample-checkout-success',
        props: {},
        components: {
        },
        data() {
            return {

            };
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
